const TOOLS = [
  // {
  //   title: 'Transform',
  //   type: 'transform',
  // },

  {
    title: 'Rotate/Flip',
    type: 'rotate',
  },
  {
    title: 'Crop',
    type: 'crop',
  },
  {
    title: 'Text',
    type: 'text',
  },
  {
    title: 'Adjust',
    type: 'adjust',
  },
  {
    title: 'Filters',
    type: 'filters',
  },
  {
    title: 'Stickers',
    type: 'stickers',
  },
];
const INITIAL_TOOL_STATE = null;
const NO_TOOL_SELECTED = '';

export default TOOLS;
export { INITIAL_TOOL_STATE, NO_TOOL_SELECTED };
